import { format, parseISO } from 'date-fns';

const defaultDateTimeFormat = 'yyyy-MM-dd, hh:mm a';
const defaultDateFormat = 'yyyy-MM-dd';

export const formatDisplayDate = (date, {
  type = 'local', defaultValue = '-', dateFormat = defaultDateTimeFormat,
} = {}) => {
  if (!date) {
    return defaultValue;
  }

  const dateParsedISO = parseISO(date);
  // dirty hack for detect UTC-0
  // used while not fixed dates in backend
  // remove when will be used one format for UTC dates
  let dateUTC = new Date(date.toLowerCase().endsWith('z') ? date : `${date}Z`);
  if (dateUTC.toString().toLowerCase() === 'invalid date') {
    dateUTC = new Date(date);
  }

  return format(type === 'local' ? dateUTC : dateParsedISO, dateFormat);
};

export const getDatesRangeByLastDays = (daysCount = 1, dateFormat = defaultDateFormat) => {
  const today = new Date();
  const lastDays = new Date(today.setDate(today.getDate() - daysCount));

  return [
    format(lastDays, dateFormat),
    format(new Date(), dateFormat),
  ];
};

export const getAllowedDatePickerRange = ({ nextDaysCount = 1, prevYearsCounts = 2 } = {}) => {
  const today = new Date();
  const nextDays = today.setDate(today.getDate() + nextDaysCount);

  return {
    min: `${(new Date()).getFullYear() - prevYearsCounts}-01-01`,
    max: (new Date(nextDays)).toISOString(),
  };
};

export const getDatesRangeObjFromDatesArray = (dates, {
  startDateName = 'startDate', endDateName = 'endDate',
} = {}) => {
  if (!dates || !dates.length || !(dates[0] || dates[0])) {
    throw new Error(`Invalid serialized dates: ${JSON.stringify(dates)}`);
  }

  return {
    [startDateName]: dates[0],
    [endDateName]: `${dates[1]} 23:59:59`,
  };
};
